// Generated from ./src/core/antlr/LambdaCalc.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import {
	ATN,
	ATNDeserializer,
	CharStream,
	DecisionState, DFA,
	Lexer,
	LexerATNSimulator,
	RuleContext,
	PredictionContextCache,
	Token
} from "antlr4";
export default class LambdaCalcLexer extends Lexer {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly T__5 = 6;
	public static readonly T__6 = 7;
	public static readonly T__7 = 8;
	public static readonly T__8 = 9;
	public static readonly T__9 = 10;
	public static readonly T__10 = 11;
	public static readonly T__11 = 12;
	public static readonly T__12 = 13;
	public static readonly T__13 = 14;
	public static readonly T__14 = 15;
	public static readonly T__15 = 16;
	public static readonly T__16 = 17;
	public static readonly T__17 = 18;
	public static readonly T__18 = 19;
	public static readonly T__19 = 20;
	public static readonly T__20 = 21;
	public static readonly T__21 = 22;
	public static readonly T__22 = 23;
	public static readonly T__23 = 24;
	public static readonly T__24 = 25;
	public static readonly T__25 = 26;
	public static readonly T__26 = 27;
	public static readonly T__27 = 28;
	public static readonly T__28 = 29;
	public static readonly T__29 = 30;
	public static readonly T__30 = 31;
	public static readonly T__31 = 32;
	public static readonly LAMBDA = 33;
	public static readonly EQ = 34;
	public static readonly NIL = 35;
	public static readonly CONS = 36;
	public static readonly ISNIL = 37;
	public static readonly TAIL = 38;
	public static readonly HEAD = 39;
	public static readonly LBRACK = 40;
	public static readonly RBRACK = 41;
	public static readonly ID = 42;
	public static readonly GREEK_TYPE = 43;
	public static readonly NATURAL_NUMBER = 44;
	public static readonly COMMA = 45;
	public static readonly ARROW = 46;
	public static readonly DOUBLEARROW = 47;
	public static readonly COLON = 48;
	public static readonly DOT = 49;
	public static readonly SEMI = 50;
	public static readonly LPAREN = 51;
	public static readonly RPAREN = 52;
	public static readonly LINE_COMMENT = 53;
	public static readonly WS = 54;
	public static readonly EOF = Token.EOF;

	public static readonly channelNames: string[] = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	public static readonly literalNames: (string | null)[] = [ null, "'typedef'", 
                                                            "'>'", "'>='", 
                                                            "'<'", "'<='", 
                                                            "'=='", "'+'", 
                                                            "'-'", "'*'", 
                                                            "'^'", "'_'", 
                                                            "'if'", "'then'", 
                                                            "'else if'", 
                                                            "'else'", "'fix'", 
                                                            "'as'", "'inl'", 
                                                            "'inr'", "'case'", 
                                                            "'of'", "'||'", 
                                                            "'Nat'", "'Bool'", 
                                                            "'Unit'", "'List '", 
                                                            "'0'", "'true'", 
                                                            "'True'", "'false'", 
                                                            "'False'", "'unit'", 
                                                            null, "'='", 
                                                            "'nil'", "'cons'", 
                                                            "'isnil'", "'tail'", 
                                                            "'head'", "'['", 
                                                            "']'", null, 
                                                            null, null, 
                                                            "','", null, 
                                                            null, "':'", 
                                                            "'.'", "';'", 
                                                            "'('", "')'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, "LAMBDA", 
                                                             "EQ", "NIL", 
                                                             "CONS", "ISNIL", 
                                                             "TAIL", "HEAD", 
                                                             "LBRACK", "RBRACK", 
                                                             "ID", "GREEK_TYPE", 
                                                             "NATURAL_NUMBER", 
                                                             "COMMA", "ARROW", 
                                                             "DOUBLEARROW", 
                                                             "COLON", "DOT", 
                                                             "SEMI", "LPAREN", 
                                                             "RPAREN", "LINE_COMMENT", 
                                                             "WS" ];
	public static readonly modeNames: string[] = [ "DEFAULT_MODE", ];

	public static readonly ruleNames: string[] = [
		"T__0", "T__1", "T__2", "T__3", "T__4", "T__5", "T__6", "T__7", "T__8", 
		"T__9", "T__10", "T__11", "T__12", "T__13", "T__14", "T__15", "T__16", 
		"T__17", "T__18", "T__19", "T__20", "T__21", "T__22", "T__23", "T__24", 
		"T__25", "T__26", "T__27", "T__28", "T__29", "T__30", "T__31", "LAMBDA", 
		"EQ", "NIL", "CONS", "ISNIL", "TAIL", "HEAD", "LBRACK", "RBRACK", "ID", 
		"GREEK_TYPE", "NATURAL_NUMBER", "COMMA", "ARROW", "DOUBLEARROW", "COLON", 
		"DOT", "SEMI", "LPAREN", "RPAREN", "LINE_COMMENT", "WS",
	];


	constructor(input: CharStream) {
		super(input);
		this._interp = new LexerATNSimulator(this, LambdaCalcLexer._ATN, LambdaCalcLexer.DecisionsToDFA, new PredictionContextCache());
	}

	public get grammarFileName(): string { return "LambdaCalc.g4"; }

	public get literalNames(): (string | null)[] { return LambdaCalcLexer.literalNames; }
	public get symbolicNames(): (string | null)[] { return LambdaCalcLexer.symbolicNames; }
	public get ruleNames(): string[] { return LambdaCalcLexer.ruleNames; }

	public get serializedATN(): number[] { return LambdaCalcLexer._serializedATN; }

	public get channelNames(): string[] { return LambdaCalcLexer.channelNames; }

	public get modeNames(): string[] { return LambdaCalcLexer.modeNames; }

	public static readonly _serializedATN: number[] = [4,0,54,328,6,-1,2,0,
	7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,
	7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,
	16,2,17,7,17,2,18,7,18,2,19,7,19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,
	2,24,7,24,2,25,7,25,2,26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,
	31,7,31,2,32,7,32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,
	7,38,2,39,7,39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,
	45,2,46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,52,
	2,53,7,53,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,2,1,2,1,2,1,3,1,3,1,
	4,1,4,1,4,1,5,1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,1,10,1,10,1,11,1,
	11,1,11,1,12,1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,13,1,13,1,13,
	1,14,1,14,1,14,1,14,1,14,1,15,1,15,1,15,1,15,1,16,1,16,1,16,1,17,1,17,1,
	17,1,17,1,18,1,18,1,18,1,18,1,19,1,19,1,19,1,19,1,19,1,20,1,20,1,20,1,21,
	1,21,1,21,1,22,1,22,1,22,1,22,1,23,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,
	24,1,24,1,25,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,27,1,27,1,27,1,27,1,27,
	1,28,1,28,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,29,1,29,1,30,1,30,1,30,1,
	30,1,30,1,30,1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,3,32,240,8,32,1,33,
	1,33,1,34,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,35,1,36,1,36,1,36,1,36,1,
	36,1,36,1,37,1,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,38,1,39,1,39,1,40,
	1,40,1,41,1,41,5,41,275,8,41,10,41,12,41,278,9,41,1,42,1,42,1,43,1,43,5,
	43,284,8,43,10,43,12,43,287,9,43,1,44,1,44,1,45,1,45,1,45,3,45,294,8,45,
	1,46,1,46,1,46,3,46,299,8,46,1,47,1,47,1,48,1,48,1,49,1,49,1,50,1,50,1,
	51,1,51,1,52,1,52,1,52,1,52,5,52,315,8,52,10,52,12,52,318,9,52,1,52,1,52,
	1,53,4,53,323,8,53,11,53,12,53,324,1,53,1,53,0,0,54,1,1,3,2,5,3,7,4,9,5,
	11,6,13,7,15,8,17,9,19,10,21,11,23,12,25,13,27,14,29,15,31,16,33,17,35,
	18,37,19,39,20,41,21,43,22,45,23,47,24,49,25,51,26,53,27,55,28,57,29,59,
	30,61,31,63,32,65,33,67,34,69,35,71,36,73,37,75,38,77,39,79,40,81,41,83,
	42,85,43,87,44,89,45,91,46,93,47,95,48,97,49,99,50,101,51,103,52,105,53,
	107,54,1,0,7,3,0,65,90,95,95,97,122,4,0,48,57,65,90,95,95,97,122,1,0,945,
	969,1,0,49,57,1,0,48,57,2,0,10,10,13,13,3,0,9,10,13,13,32,32,334,0,1,1,
	0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,
	1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,0,0,0,0,23,1,0,0,
	0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,0,33,1,0,0,0,0,35,
	1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,1,0,0,0,0,45,1,0,0,
	0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,0,55,1,0,0,0,0,57,
	1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,65,1,0,0,0,0,67,1,0,0,
	0,0,69,1,0,0,0,0,71,1,0,0,0,0,73,1,0,0,0,0,75,1,0,0,0,0,77,1,0,0,0,0,79,
	1,0,0,0,0,81,1,0,0,0,0,83,1,0,0,0,0,85,1,0,0,0,0,87,1,0,0,0,0,89,1,0,0,
	0,0,91,1,0,0,0,0,93,1,0,0,0,0,95,1,0,0,0,0,97,1,0,0,0,0,99,1,0,0,0,0,101,
	1,0,0,0,0,103,1,0,0,0,0,105,1,0,0,0,0,107,1,0,0,0,1,109,1,0,0,0,3,117,1,
	0,0,0,5,119,1,0,0,0,7,122,1,0,0,0,9,124,1,0,0,0,11,127,1,0,0,0,13,130,1,
	0,0,0,15,132,1,0,0,0,17,134,1,0,0,0,19,136,1,0,0,0,21,138,1,0,0,0,23,140,
	1,0,0,0,25,143,1,0,0,0,27,148,1,0,0,0,29,156,1,0,0,0,31,161,1,0,0,0,33,
	165,1,0,0,0,35,168,1,0,0,0,37,172,1,0,0,0,39,176,1,0,0,0,41,181,1,0,0,0,
	43,184,1,0,0,0,45,187,1,0,0,0,47,191,1,0,0,0,49,196,1,0,0,0,51,201,1,0,
	0,0,53,207,1,0,0,0,55,209,1,0,0,0,57,214,1,0,0,0,59,219,1,0,0,0,61,225,
	1,0,0,0,63,231,1,0,0,0,65,239,1,0,0,0,67,241,1,0,0,0,69,243,1,0,0,0,71,
	247,1,0,0,0,73,252,1,0,0,0,75,258,1,0,0,0,77,263,1,0,0,0,79,268,1,0,0,0,
	81,270,1,0,0,0,83,272,1,0,0,0,85,279,1,0,0,0,87,281,1,0,0,0,89,288,1,0,
	0,0,91,293,1,0,0,0,93,298,1,0,0,0,95,300,1,0,0,0,97,302,1,0,0,0,99,304,
	1,0,0,0,101,306,1,0,0,0,103,308,1,0,0,0,105,310,1,0,0,0,107,322,1,0,0,0,
	109,110,5,116,0,0,110,111,5,121,0,0,111,112,5,112,0,0,112,113,5,101,0,0,
	113,114,5,100,0,0,114,115,5,101,0,0,115,116,5,102,0,0,116,2,1,0,0,0,117,
	118,5,62,0,0,118,4,1,0,0,0,119,120,5,62,0,0,120,121,5,61,0,0,121,6,1,0,
	0,0,122,123,5,60,0,0,123,8,1,0,0,0,124,125,5,60,0,0,125,126,5,61,0,0,126,
	10,1,0,0,0,127,128,5,61,0,0,128,129,5,61,0,0,129,12,1,0,0,0,130,131,5,43,
	0,0,131,14,1,0,0,0,132,133,5,45,0,0,133,16,1,0,0,0,134,135,5,42,0,0,135,
	18,1,0,0,0,136,137,5,94,0,0,137,20,1,0,0,0,138,139,5,95,0,0,139,22,1,0,
	0,0,140,141,5,105,0,0,141,142,5,102,0,0,142,24,1,0,0,0,143,144,5,116,0,
	0,144,145,5,104,0,0,145,146,5,101,0,0,146,147,5,110,0,0,147,26,1,0,0,0,
	148,149,5,101,0,0,149,150,5,108,0,0,150,151,5,115,0,0,151,152,5,101,0,0,
	152,153,5,32,0,0,153,154,5,105,0,0,154,155,5,102,0,0,155,28,1,0,0,0,156,
	157,5,101,0,0,157,158,5,108,0,0,158,159,5,115,0,0,159,160,5,101,0,0,160,
	30,1,0,0,0,161,162,5,102,0,0,162,163,5,105,0,0,163,164,5,120,0,0,164,32,
	1,0,0,0,165,166,5,97,0,0,166,167,5,115,0,0,167,34,1,0,0,0,168,169,5,105,
	0,0,169,170,5,110,0,0,170,171,5,108,0,0,171,36,1,0,0,0,172,173,5,105,0,
	0,173,174,5,110,0,0,174,175,5,114,0,0,175,38,1,0,0,0,176,177,5,99,0,0,177,
	178,5,97,0,0,178,179,5,115,0,0,179,180,5,101,0,0,180,40,1,0,0,0,181,182,
	5,111,0,0,182,183,5,102,0,0,183,42,1,0,0,0,184,185,5,124,0,0,185,186,5,
	124,0,0,186,44,1,0,0,0,187,188,5,78,0,0,188,189,5,97,0,0,189,190,5,116,
	0,0,190,46,1,0,0,0,191,192,5,66,0,0,192,193,5,111,0,0,193,194,5,111,0,0,
	194,195,5,108,0,0,195,48,1,0,0,0,196,197,5,85,0,0,197,198,5,110,0,0,198,
	199,5,105,0,0,199,200,5,116,0,0,200,50,1,0,0,0,201,202,5,76,0,0,202,203,
	5,105,0,0,203,204,5,115,0,0,204,205,5,116,0,0,205,206,5,32,0,0,206,52,1,
	0,0,0,207,208,5,48,0,0,208,54,1,0,0,0,209,210,5,116,0,0,210,211,5,114,0,
	0,211,212,5,117,0,0,212,213,5,101,0,0,213,56,1,0,0,0,214,215,5,84,0,0,215,
	216,5,114,0,0,216,217,5,117,0,0,217,218,5,101,0,0,218,58,1,0,0,0,219,220,
	5,102,0,0,220,221,5,97,0,0,221,222,5,108,0,0,222,223,5,115,0,0,223,224,
	5,101,0,0,224,60,1,0,0,0,225,226,5,70,0,0,226,227,5,97,0,0,227,228,5,108,
	0,0,228,229,5,115,0,0,229,230,5,101,0,0,230,62,1,0,0,0,231,232,5,117,0,
	0,232,233,5,110,0,0,233,234,5,105,0,0,234,235,5,116,0,0,235,64,1,0,0,0,
	236,240,5,955,0,0,237,238,5,92,0,0,238,240,5,121,0,0,239,236,1,0,0,0,239,
	237,1,0,0,0,240,66,1,0,0,0,241,242,5,61,0,0,242,68,1,0,0,0,243,244,5,110,
	0,0,244,245,5,105,0,0,245,246,5,108,0,0,246,70,1,0,0,0,247,248,5,99,0,0,
	248,249,5,111,0,0,249,250,5,110,0,0,250,251,5,115,0,0,251,72,1,0,0,0,252,
	253,5,105,0,0,253,254,5,115,0,0,254,255,5,110,0,0,255,256,5,105,0,0,256,
	257,5,108,0,0,257,74,1,0,0,0,258,259,5,116,0,0,259,260,5,97,0,0,260,261,
	5,105,0,0,261,262,5,108,0,0,262,76,1,0,0,0,263,264,5,104,0,0,264,265,5,
	101,0,0,265,266,5,97,0,0,266,267,5,100,0,0,267,78,1,0,0,0,268,269,5,91,
	0,0,269,80,1,0,0,0,270,271,5,93,0,0,271,82,1,0,0,0,272,276,7,0,0,0,273,
	275,7,1,0,0,274,273,1,0,0,0,275,278,1,0,0,0,276,274,1,0,0,0,276,277,1,0,
	0,0,277,84,1,0,0,0,278,276,1,0,0,0,279,280,7,2,0,0,280,86,1,0,0,0,281,285,
	7,3,0,0,282,284,7,4,0,0,283,282,1,0,0,0,284,287,1,0,0,0,285,283,1,0,0,0,
	285,286,1,0,0,0,286,88,1,0,0,0,287,285,1,0,0,0,288,289,5,44,0,0,289,90,
	1,0,0,0,290,291,5,45,0,0,291,294,5,62,0,0,292,294,5,8594,0,0,293,290,1,
	0,0,0,293,292,1,0,0,0,294,92,1,0,0,0,295,296,5,61,0,0,296,299,5,62,0,0,
	297,299,5,8658,0,0,298,295,1,0,0,0,298,297,1,0,0,0,299,94,1,0,0,0,300,301,
	5,58,0,0,301,96,1,0,0,0,302,303,5,46,0,0,303,98,1,0,0,0,304,305,5,59,0,
	0,305,100,1,0,0,0,306,307,5,40,0,0,307,102,1,0,0,0,308,309,5,41,0,0,309,
	104,1,0,0,0,310,311,5,47,0,0,311,312,5,47,0,0,312,316,1,0,0,0,313,315,8,
	5,0,0,314,313,1,0,0,0,315,318,1,0,0,0,316,314,1,0,0,0,316,317,1,0,0,0,317,
	319,1,0,0,0,318,316,1,0,0,0,319,320,6,52,0,0,320,106,1,0,0,0,321,323,7,
	6,0,0,322,321,1,0,0,0,323,324,1,0,0,0,324,322,1,0,0,0,324,325,1,0,0,0,325,
	326,1,0,0,0,326,327,6,53,0,0,327,108,1,0,0,0,8,0,239,276,285,293,298,316,
	324,1,6,0,0];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!LambdaCalcLexer.__ATN) {
			LambdaCalcLexer.__ATN = new ATNDeserializer().deserialize(LambdaCalcLexer._serializedATN);
		}

		return LambdaCalcLexer.__ATN;
	}


	static DecisionsToDFA = LambdaCalcLexer._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );
}